import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'custom-checkbox, [customCheckbox]',
  templateUrl: 'checkbox.component.html',
  styleUrls: ['checkbox.component.scss']
})
export class CheckboxComponent {
  @Input() label: any = '';
  @Input() disabled: boolean = false;
  @Input() name: string = '';
  @Input() checked: boolean = false;

  @Output() checkboxChange: EventEmitter<Event> = new EventEmitter();
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('class.custom-control') customControl: boolean = true;

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

  @HostBinding('class.custom-checkbox') customCheckbox: boolean = true;

  @HostBinding('class.no-label') get noLabel(): boolean {
    return !this.label.length;
  }

  onChange(event: Event) {
    this.checked = !this.checked;
    this.checkboxChange.emit(event);
    this.checkedChange.emit(this.checked);
  }
}
